<template>
  <div>
    <v-tooltip color="deep-purple" right>
      <template v-slot:activator="{ on }">
        <v-fab-transition>
          <v-btn
            v-show="show"
            :to="{ name: 'UserEdit', params: { userId: 'new' } }"
            color="deep-purple"
            style="left:90px;top: 28px;"
            absolute
            fab
            left
            small
            v-on="on"
          >
            <v-icon color="light">mdi-account-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Add a recipient or admin</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'AddUserButton',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isDialogShown: false
  }),
  methods: {
    showDialog () {
      this.isDialogShown = true
    }
  }
}
</script>
